import React from "react";

const Profile = () => {
  return (
    <div>
      <h1>hello frofile </h1>
    </div>
  );
};

export default Profile;
